import { Component, OnInit } from '@angular/core';
import { LivreurUberService } from '../livreur-uber.service';

@Component({
  selector: 'app-nav-bar',
  templateUrl: './nav-bar.component.html',
  styleUrls: ['./nav-bar.component.css']
})
export class NavBarComponent implements OnInit {

  
  constructor(private service : LivreurUberService) { }

  nombreGateauxDansLePanier(){

   return this.service.livrerLacommande().length;

  }




  ngOnInit(): void {
  }

}
